import $ from 'jquery';

export default function(jquerySelector){
  var serializedArray = $(jquerySelector).serializeArray();
  var simpleObject = {};
  $.each(serializedArray, function(index, kv){
    if(kv['name'] in simpleObject){
      simpleObject[kv['name']] += ',' + kv['value'];
    } else{
      simpleObject[kv['name']] = kv['value'];
    }
  });
  return simpleObject;
}